module.exports = __webpack_public_path__ + "media/images/pic/testimonials/wiktoria-eddd89e1921a10ee8ea985385e5cc416.jpg";